import { createReducer, on } from '@ngrx/store';
import { initialState, LocationsSkeletonState } from './locations-skeleton-state';
import { SkeletonGeneralActions, SkeletonRightPanelActions, SkeletonBottomPanelActions } from './locations-skeleton-actions';

export const locationsSkeletonReducer = createReducer(initialState,
    on(SkeletonGeneralActions.initializeContainerDimensionsSuccess, (state): LocationsSkeletonState => ({
      ...state,
      containerDimensionsInitialized: true,
    })),
    on(SkeletonGeneralActions.toggleResizing, (state): LocationsSkeletonState => ({
      ...state,
      resizing: !state.resizing,
    })),

    on(SkeletonRightPanelActions.toggleRightPanel, (state): LocationsSkeletonState => ({
      ...state,
      rightPanelActive: !state.rightPanelActive,
      unsavedChangesInRightPanelTab: false, // user had to OK this action
    })),
    on(SkeletonRightPanelActions.selectRightPanelTab, (state, { payload }): LocationsSkeletonState => ({
      ...state,
      selectedRightPanelTab: payload,
      unsavedChangesInRightPanelTab: false, // user had to OK this action
    })),
    on(SkeletonRightPanelActions.setUnsavedChangesInRightPanelTab, (state, { unsavedChangesInRightPanelTab }): LocationsSkeletonState => ({
      ...state,
      unsavedChangesInRightPanelTab: unsavedChangesInRightPanelTab,
    })),
    on(SkeletonRightPanelActions.setRightPanelRelativeWidth,
        (state, { rightPanelRelativeWidth }): LocationsSkeletonState => ({
          ...state,
          rightPanelRelativeWidth: rightPanelRelativeWidth,
        })),

    on(SkeletonBottomPanelActions.toggleBottomPanel, (state): LocationsSkeletonState => ({
      ...state,
      bottomPanelActive: !state.bottomPanelActive,
      unsavedChangesInBottomPanelTab: false, // user had to OK this action
    })),
    on(SkeletonBottomPanelActions.selectBottomPanelTab, (state, { payload }): LocationsSkeletonState => ({
      ...state,
      selectedBottomPanelTab: payload,
      unsavedChangesInBottomPanelTab: false, // user had to OK this action
    })),
    on(SkeletonBottomPanelActions.setUnsavedChangesInBottomPanelTab, (state, { unsavedChangesInBottomPanelTab }): LocationsSkeletonState => ({
      ...state,
      unsavedChangesInBottomPanelTab: unsavedChangesInBottomPanelTab,
    })),
    on(SkeletonBottomPanelActions.setBottomPanelRelativeHeight,
        (state, { bottomPanelRelativeHeight }): LocationsSkeletonState => ({
          ...state,
          bottomPanelRelativeHeight: bottomPanelRelativeHeight,
        })),
);



